export default __webpack_public_path__ + "static/media/icon-facebook.c0174669.svg";